import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import release1 from '../assets/release1.png';
import release2 from '../assets/release2.png';
import Card from './Card';

export default function Release() {
  return (
    <>
    <div className="releases">
      <div className="release orange">
        <div className="content">
          <h2 className="title">Initial Release 4/11</h2>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. <a href='#'>OpenSea</a> </p>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
          <a href='#' className='link'>Check them out <BsArrowRight /> </a>
        </div>
        <div className="image">
          <img src={release1} alt="release1" />
          <div className="ellipse pink"></div>
        </div>
      </div>
      <div className="release green">
        <div className="card-container">
          <Card image={release2} series="Gloop series" title="Purple Man" price={3.95} tag={129} time={2} />
          <div className="ellipse orange"></div>
        </div>
        <div className="content">
          <h2 className="title">Initial Release 4/11</h2>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit. <a href='#'>OpenSea</a> </p>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
          <p className="description">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
          <a href='#' className='link'>Check them out <BsArrowRight /> </a>
        </div>
      </div>
    </div>
    </>
  )
}
